const apiUrl = process.env.REACT_APP_API_URL;

export const GenerateEnunciat = async (instructions: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/generate-enunciat`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ prompt: instructions })
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        // The backend returns a String (content), not a JSON object with properties
        // But fetch response.text() should be used if it is raw string
        // Let's check backend return. It returns ResponseEntity.ok(String).
        // If content-type is text, user .text(). If json containing string, use .json()
        // Spring Boot usually returns plain text if the body is String and no MediaType specified.
        // However, usually it is better to return JSON.
        // In my java code: return ResponseEntity.ok(content.trim()); -> content is String.
        // This will likely be text/plain.

        return await response.text();
    } catch (error) {
        console.log('Error:', error);
        throw error;
    }
};
